//import { debug } from 'webpack'
import webapi from '../../api/webapi'
/**
   通常設定
*/

const state = {
  current_submenu: null,
  shop_code: '',
  shop_ip: '',
  api_version: '',
  port_no: '',
  slip_no: '',
  slip_date: '',
  table_no : '',
  sub_menu_list: [],
  sub_menu_name:'',
  sub_menu_name_jp:'',
  sub_menu_name_en:'',
  sub_menu_name_ch:'',
  qa_url:'',
  line_url:'',
  line_page_enabled:false,
  slip_info:null,
  submenu_action_visible:false,
  
}

const getters = {
  SlipInfo: state => state.slip_info,
  ShopCode: state => state.shop_code,
  ShopIP: state => state.shop_ip,
  ApiVersion: state => state.api_version,
  PortNo: state => state.port_no,
  SlipNo: state => state.slip_no,
  SlipDate: state => state.slip_date,
  TableNo: state => state.table_no,
  SubMenuList: state => state.sub_menu_list,
  SubMenuName: state => state.sub_menu_name,
  SubMenuNameJp: state => state.sub_menu_name_jp,
  SubMenuNameEn: state => state.sub_menu_name_en,
  SubMenuNameCh: state => state.sub_menu_name_ch,
  SubmenuActionVisible: state => state.submenu_action_visible,
  AllPageList:state => state.all_page_list,
  isSubMenuExist: state => {
    if(state.sub_menu_list.length>0){
      return true
    }else{
      return false
    }
  },
  GetSubmenuByCode: state => (code)=>{
    state.sub_menu_list.forEach(function(item){
      var result=null
      if(item.Goods==code){
        result= item
      }
      return result
    })
  },
  isSubMenuCodeExist: state =>(code)=> {
    var result=false
    state.sub_menu_list.forEach(function(item){
      if(item.Goods==code){
        result=true
      }
    })
    return result
  },
  CurrentSubmenu: state => state.current_submenu,
  QuestionnaireURL: state => state.qa_url,
  LineFriendURL: state => state.line_url,
  LinePageEnabled: state => state.line_page_enabled,
}

// actions
const actions = {
  /**
    初期設定（伝票照会APIをコールする）
  */
  initialize({ commit,getters,dispatch}, param) {
    
    commit('updateShopCode', param['shop_code']);
    commit('updateShopIP', param['shop_ip']);
    commit('updateApiVersion', param['api_version']);
    commit('updatePortNo', param['port_no']);
    commit('updateSlipNo', param['slip_no']);
    commit('updateSlipDate', param['slip_date']);
    //commit('updateTableNo', param['table_no']);
    
    //dispatch('showMessage',param['shop_code']+','+param['shop_ip']+','+param['port_no']+','+param['slip_no'])//実行ログ

    return new Promise((resolve, reject) => {
      webapi
        .request(
          'slip',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
          }
        )
        .then(result => {
          //dispatch('showLogMessage','call 伝票照会API')//実行ログ
          if(result.Status){
            if ('GoodsList' in result) {
              commit('updateSubMenuList', result.GoodsList.Detail);
            }else{
              commit('updateSubMenuList', []);
            }
            
            commit('updateTableNo', result.TableNo);
            commit('updateQAURL', result.qa_url);
            commit('updateLineURL', result.line_url);
            commit('updateLinePageEnabled', result.line_page_enabled);
            commit('updateSlipInfo',result)
            resolve(result)
          }else{
            debugger
            //dispatch('showErrorMessage','Network Error')
            reject()
          }
          
        })
        .catch(errors => {
          debugger
          if(errors!="ネットワークに問題があります。<br>しばらくして再度実行してください。"){
            dispatch('showErrorMessage',getters.ConvertAppError(errors))
          }
          reject()
        })
      
    })
    
  },
  SendAlcoholCheck({dispatch,getters}, answer) {

    return new Promise((resolve, reject) => {
      webapi
        .request(
          'alcohol_check',
          {
            shop_ip:    getters.ShopIP,
            shop_port:  getters.PortNo,
            slip_date:  getters.SlipDate,
            shop_code:  getters.ShopCode,
            slip_no:    getters.SlipNo,
            answer:     answer,
          }
        )
        .then(result => {
          //dispatch('showLogMessage','call 伝票照会API')//実行ログ
          resolve(result)
        })
        .catch(errors => {
          dispatch('showErrorMessage',getters.ConvertAppError(errors))
          reject(getters.ConvertAppError(errors))
        })
      
    })
  
    
  },

  /*
    放題メニューなど、サブメニューページを呼び出した時にセットされる
    ページの移動が発生するたびにクリアされる前提
  */
  SetCurrentSubmenu({commit},param){
    commit('updateCurrentSubmenu', param);
  },

  SetSubmenuActionVisible({commit},param){
    commit('updateSubmenuActionVisible', param);
  }
  
}

// mutations
const mutations = {
  updateSubmenuActionVisible(state, value) {
    state.submenu_action_visible = value
  },
  updateShopCode(state, value) {
    state.shop_code = value
  },
  updateShopIP(state, value) {
    state.shop_ip = value
  },
  updateApiVersion(state, value) {
    state.api_version = value
  },
  updatePortNo(state, value) {
    state.port_no = value
  },
  updateSlipNo(state, value) {
    state.slip_no = value
  },
  updateSubmenuName(state, value) {
    state.sub_menu_name = value
  },
  updateSlipDate(state, value) {
    state.slip_date = value
  },
  updateTableNo(state, value) {
    state.table_no = value
  },
  updateQAURL(state, value) {
    state.qa_url = value
  },
  updateLineURL(state, value) {
    state.line_url = value
  },
  updateLinePageEnabled(state, value) {
    state.line_page_enabled = value
  },
  updateSlipInfo(state, value) {
    state.slip_info = value
  },
  updateCurrentSubmenu(state, value) {
    state.current_submenu = value
  },
  
  updateSubMenuList(state, list){
    if(Array.isArray(list)){
      //テスト
      /*
      list.forEach(function(item){
        item['LockTime']=0.5
      })
      */
      state.sub_menu_list=list
    }else{
      state.sub_menu_list=[list]
    }
    
    if(state.sub_menu_list.length>1){
      state.sub_menu_name_jp='放題メニュー<br>はこちら'
      state.sub_menu_name_en='Click here <br>for free menu'
      state.sub_menu_name_ch='点击这里免费菜单'
      //state.sub_menu_name_jp=getters.localizeLabel("Tabbar", "submenu_button_titile")

    }else if(state.sub_menu_list.length==1){
      if('GoodsNamee' in state.sub_menu_list[0]){
        state.sub_menu_name_jp=state.sub_menu_list[0].GoodsName
        state.sub_menu_name_en=state.sub_menu_list[0].GoodsNamee
        state.sub_menu_name_ch=state.sub_menu_list[0].GoodsNamec
      }
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js